import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 12h-12","key":"svg-0"}],["path",{"d":"M7 8l-4 4l4 4","key":"svg-1"}],["path",{"d":"M12 21a9 9 0 0 0 0 -18","key":"svg-2"}]]

const IconArrowRightFromArc = createReactComponent('outline', 'arrow-right-from-arc', 'ArrowRightFromArc', __iconNode);

export default IconArrowRightFromArc;